import Vue from "vue";
import App from "./App.vue";
import VueI18n from "vue-i18n";
import CountryFlag from "vue-country-flag";
import VueYoutube from "vue-youtube";
// Vue Router
import Router from "vue-router";
import router from "./router";

Vue.use(Router);
Vue.use(VueI18n);
Vue.config.productionTip = false;
Vue.component("country-flag", CountryFlag);

Vue.use(VueYoutube);
//Mixins/utilities
import constants from "./constants";

import { languages } from "./translations";
import { defaultLocale } from "./translations";

const messages = Object.assign(languages);

let i18n = new VueI18n({
  locale: defaultLocale,
  fallbackLocale: "es",
  messages
});

// Vue Prototype override
Vue.prototype.CONSTANTS = constants;

//Local storage
Storage.prototype.setObject = function(key, value) {
  this.setItem(key, JSON.stringify(value));
};

Storage.prototype.getObject = function(key) {
  let value = this.getItem(key);
  return value && JSON.parse(value);
};

new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount("#app");
